$(function () {
    $('.training-prijs-block').on('click', function (e) {
        if( $(this).find('.inschrijven-optie__inschrijven').length ) {
            $(this).find('.inschrijven-optie__inschrijven').submit();
        } else {
            window.location.href = $(this).find('a').first().prop('href');
        }
    });
});